<template lang="pug">
#docContainer(v-loading='loading'
  element-loading-text='文档加载中...'
  element-loading-background='rgba(0, 0, 0, 0.5)')
  iframe.iframe(ref='iframeID')
  application(ref='docApplication' type="pdf" v-if="docloaded")
</template>

<script>
import { scanUrl, creatWatermarkUserInfo } from "@/CommonDP/mongeView/utils";
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import application from "@/CommonDP/mongeView/appView/applicationH5.vue";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mapState } from "vuex";

export default {
  components: { application },
  data() {
    return {
      docloaded: false,
      loading: true,
      createUserDept: "",
      questionId: '',
      flowInstanceId: '',
      shareId: ''
    };
  },
  computed: {
    ...mapState({
      loginUserId: state => state.user.userId
    }),
    docmentData() {
      return JSON.parse(mongeApp.other.fileInfo);
    },
    userId() {
      return this.$route.query.userId || this.loginUserId;
    }
  },
  watch: {
    $route: {
      async handler() {
        this.questionId = this.$route.query.questionId;
        this.flowInstanceId = this.$route.query.flowInstanceId || '';
        this.shareId = this.$route.query.i || '';
        if (this.questionId) {
          await this.getAnnotationData(this.questionId, this.flowInstanceId, this.shareId);
        }
      },
      deep: true
    }
  },
  created () {
    this.getFileInfo();
  },
  methods: {
    async getFileInfo() {
      const { fileId, versionId: fileVersion, sharerId = "", i = "" } = this.$route.query;
      mongeMutations.setShareId(i);
      if (!fileId) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      const { data } = await mongeService.getFileDetails(fileId, i);
      document.title = data.fileName;
      const urlData = {
        fileId,
        fileName: encodeURIComponent(data.fileName),
        prjId: data.prjId,
        fileVersion
      };
      mongeMutations.setDocmentView(JSON.stringify(urlData));
      await mongeApiMlib.initEvent();
      await this.getRequestData(sharerId);
    },
    getRequestData(sharerId) {
      window.callBackError = () => {
        this.loadingTxt = "文档加载失败";
      };
      window.callBackSuccess = () => {
        this.loading = false;
        // 添加水印
        const ifreamBox = this.$refs.iframeID;
        const text = creatWatermarkUserInfo();
        ifreamBox.contentWindow.waterMark(text);
        this.docloaded = true;
      };
      const otherData = this.docmentData;
      const pdfUrl = scanUrl(otherData.fileId, otherData.fileVersion, sharerId);
      this.$refs.iframeID.src = `./pdf/web/viewer.html?file=${encodeURIComponent(pdfUrl)}#page=${this.createUserDept}`;
    },
    async getNotationData(questionId, flowInstanceId, shareId) {
      const res = await mongeService.getDrawingQuestionDetails(questionId, this.userId, flowInstanceId, shareId);
      const anchorPoint = res.data?.anchorPoint;
      const ifreamBox = this.$refs.iframeID;
      const { PDFViewerApplication } = ifreamBox.contentWindow;
      PDFViewerApplication.page = Number(anchorPoint) || 1;
    }
  }

};
</script>
<style lang="scss" scoped>
#docContainer{
  width: 100%;
  height: 100%;
  position: relative;
  .iframe{
    padding-top: 46px;
    position: absolute;
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
